import { ReactNode, isValidElement, useMemo } from "react";

import { useRunOnceWhen } from "@nens/react/hooks";

import { RanaFormErrors } from "../rana-form-non-field-errors";

// Check if RanaForm.Errors is rendered in children
export const useWarnNoNonFieldErrorComponent = (children: ReactNode) => {
  // Check if RanaForm.Errors is rendered in children
  const hasErrorsComponent = useMemo(() => {
    const checkForErrors = (node: ReactNode): boolean => {
      if (!node) return false;
      if (Array.isArray(node)) return node.some(checkForErrors);
      if (isValidElement(node)) {
        if (node.type === RanaFormErrors) return true;
        return checkForErrors(node.props.children);
      }
      return false;
    };
    return checkForErrors(children);
  }, [children]);

  useRunOnceWhen(!hasErrorsComponent, () => {
    console.warn(
      "RanaForm.Errors component not found in RanaForm children. " +
        "RanaForm.Errors must be rendered to display validation errors."
    );
  });
};
